// Купить спекакль зрителю по id театра и id события
// это пушка, но никаких проверок пока нет

import HallBuyByTIDaEID from './HallBuyByTIDaEID';
export default HallBuyByTIDaEID;
